import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { ExternalTxLink } from "@/domains/common/components/external-tx-link"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodySM } from "@/domains/design/components/body-sm"
import { formatCurrency } from "@/domains/library"

interface WithdrawWithdrawnProps {
  store: WithdrawStore
  governanceTokenSymbol?: string
}

export const WithdrawWithdrawn = observer(({ store, governanceTokenSymbol = "SCALE" }: WithdrawWithdrawnProps) => {
  if (!store.lock) return null

  return (
    <MultilineMessageBox variant="success" icon={<MessageBoxIcon size={"md"} variant="success" />}>
      <BodySM className="text-success-text">
        Successfully withdrawn {formatCurrency(store.lock.lockAmount)} {governanceTokenSymbol} from NFT #{store.lock.id}{" "}
        🎉
      </BodySM>
      <div className="flex items-center justify-start gap-2">
        {store.resetTxHash && <ExternalTxLink url={store.resetTxHashUrl} title="View reset tx" className="mt-2" />}
        {store.withdrawTxHash && (
          <ExternalTxLink url={store.withdrawTxHashUrl} title="View withdraw tx" className="mt-2" />
        )}
      </div>
    </MultilineMessageBox>
  )
})
